import type { ReactElement } from 'react';
import { useT } from '../../../../app/di';
import { Alert } from '../../../../ui-kit/Alert/Alert';
import { Button, LinkButton } from '../../../../ui-kit/Button/Button';
import { Card } from '../../../../ui-kit/Card/Card';
import styles from './PackageCaption.module.scss';

export interface PackageCaptionProps {
  caption: string;
  droppedTags: readonly string[];
  channelUrl: string;
  /** Итог последнего копирования: null — ещё не копировали. */
  copied: boolean | null;
  onCopy(): void;
}

/** PUB-UC-2: подпись для канала — скопировать одной кнопкой и открыть канал. */
export function PackageCaption({ caption, droppedTags, channelUrl, copied, onCopy }: PackageCaptionProps): ReactElement {
  const { t } = useT();
  return (
    <Card
      title={t('publishing.package.caption')}
      actions={
        <Button icon="copy" onClick={onCopy}>
          {t('publishing.package.copy')}
        </Button>
      }
    >
      <div className="u-stack">
        {copied === true ? <Alert tone="success">{t('publishing.package.copied')}</Alert> : null}
        {copied === false ? <Alert tone="warning">{t('publishing.package.copyFailed')}</Alert> : null}
        <pre className={styles.caption} data-testid="package-caption">
          {caption}
        </pre>
        {droppedTags.length > 0 ? <p className="u-muted u-small">{t('publishing.package.droppedTags', { tags: droppedTags.map((x) => `#${x}`).join(' ') })}</p> : null}
        {channelUrl ? (
          <div>
            <LinkButton href={channelUrl} icon="external" external>
              {t('publishing.package.openChannel')}
            </LinkButton>
          </div>
        ) : null}
      </div>
    </Card>
  );
}
